export default "assets/a93a17c8757b1dc890d74fe895893e00.png";